import { render, staticRenderFns } from "./CardChangePassword.vue?vue&type=template&id=5ba86d0c"
import script from "./CardChangePassword.vue?vue&type=script&lang=js"
export * from "./CardChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports